import { INTERFACES } from "../components/organisms/AppDrawers/drawers.constants";
import {
  DateEditor,
  DropdownEditor,
  FileEditor,
  NumericEditor,
  TextEditor,
  FloatNumEditor,
  JsonEditor,
} from "../components/customEditors";
import { ToggleRenderer } from "../components/customRenderers";

const {
  DATE_TIME,
  REPEATER_FIELDS,
  SELECT,
  IMAGE,
  FILE,
  NUMBER,
  BOOLEAN,
  FLOAT_NUMBER,
  JSON_TYPE,
} = INTERFACES;

const getEditor = (field) => {
  switch (field.meta.interface) {
    case DATE_TIME:
      return DateEditor;
    case REPEATER_FIELDS:
    case SELECT:
      return DropdownEditor(field);
    case IMAGE:
    case FILE:
      return FileEditor(field);
    case BOOLEAN:
      return ToggleRenderer;
    case NUMBER:
      return NumericEditor;
    case FLOAT_NUMBER:
      return FloatNumEditor;
    case JSON_TYPE:
      return JsonEditor;
    default:
      return TextEditor;
  }
};

export default getEditor;
